import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../config/config';
import { Observable } from 'rxjs';
import { AssetRating } from '../models/assetRating.model';

@Injectable({
  providedIn: 'root'
})
export class AssetRatingService {
  
  private pathApi = this.config.setting['pathApi'] + "assetRating/";

  constructor(private http: HttpClient, private config: AppConfig) { }

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn);
  }

  save(assetRating: AssetRating): Observable<any> {
    return this.http.post(`${this.pathApi}save`, assetRating);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`);
  }

  getAllForSelect(): Observable<any> {
    return this.http.get(`${this.pathApi}getAllForSelect`);
  }
}
